import 'babel-polyfill';

import Vue from 'vue';

import 'normalize.css/normalize.css';// A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n

Vue.use(ElementUI, { locale });

import '@/styles/index.scss'; // global css

import App from './App';
import router from './router';
import store from './store';
import './icons';
// import '@/permission'; // permission control

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faLock, faEye, faMobileAlt, faEnvelopeOpen,faHome, faMobile, faList, faGift }
  from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faUser, faLock, faEye, faMobileAlt, faEnvelopeOpen, faHome, faMobile, faList, faGift);

Vue.component('font-awesome-icon', FontAwesomeIcon);

import filters from './filters';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;


new Vue({
  el: '#root',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js